import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';
import type {
  AuthMethodKind,
  CreatePlatformProfileInput,
} from '../../domain/entities/user.entity';

/**
 * Ações de identidade a partir do detalhe do usuário: criar PlatformProfile (dar
 * acesso a um novo scope) e desvincular um método de login. Ambas alteram o
 * detalhe → invalidam `['users', userId]`.
 */
export function useIdentityActions(userId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);
  const invalidate = () =>
    void queryClient.invalidateQueries({ queryKey: ['users', userId] });

  const createPlatformProfile = useMutation({
    mutationFn: (input: CreatePlatformProfileInput) =>
      repository.createPlatformProfile(input),
    onSuccess: invalidate,
  });

  const unlinkIdentity = useMutation({
    mutationFn: (vars: { accountId: string; method: AuthMethodKind }) =>
      repository.unlinkIdentity(vars.accountId, vars.method),
    onSuccess: invalidate,
  });

  return { createPlatformProfile, unlinkIdentity };
}
